import { render, staticRenderFns } from "./FotoPendukungJenisBarang.vue?vue&type=template&id=45f58b88&"
import script from "./FotoPendukungJenisBarang.vue?vue&type=script&lang=js&"
export * from "./FotoPendukungJenisBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports